import React, { Fragment, useEffect } from 'react'
import { Container, Button, Card, Col, CardBody, Row, CardHeader, Table, CardFooter, ButtonGroup, Input } from 'reactstrap';
import 'animate.css';
import "react-datetime/css/react-datetime.css";
import './styleQuoterMic.css';
import '../../micro/cotizacion/StyleQuoterM.css'
import 'moment/locale/es';
import FormatNumbers from '../../../utils/formatNumbers';
import { ConfigServer } from '../../../data/config';
import Select from 'react-select';

export const IndexPreviewQuoter = ({
    viewQuoter, checkTypeClient, informationCompany,
    loadingCreate, formQuoterMic, informationPatient,
    nameBranch, downloadQuoter, updateQuatation, saveQuatation,
    handleNavigateSampling, handleClosedQuoter,

    handleFilterValues, listCompanies, handleSearchClient,
    isHoveredClean, isHovered, getFilter,
    handleCleanFilter, handleMouseEnterClean, handleMouseEnter,
    handleMouseLeaveClean, handleMouseLeave,


    total_tax, optionsTotal, handleNewQuatation,
    handleViewQuoter, handleChangeTypeClient,

    handleGoBack

}) => {

    useEffect(() => {
        const tabMenu = document.querySelector('.custom-tabmenu-blue-report');

        if (tabMenu) {
            tabMenu.style.display = 'none';
        }

        return () => {
            if (tabMenu) {
                tabMenu.style.display = '';
            }
        };
    }, []);


    return (
        <Fragment>
            <>
                {/* <Container fluid={true} className='bg-barra1 '> */}
                <Row>

                    {
                        viewQuoter &&
                        <Col sm="12" md="12" lg="12" >
                            <Row className="quote-premium-header">

                                <Col md="12">

                                    <div className="quote-premium-card">
                                        <div className="quote-premium-inline">
                                            <div className="quote-left">

                                                <div className="quote-inline-logo">

                                                    <img
                                                        // src={logoHumanly}
                                                        src={
                                                            ConfigServer.serverUrl +
                                                            "/api/Configuration/Logo"
                                                        }
                                                        className="quote-premium-logo"
                                                        alt="Logo"
                                                    />

                                                </div>

                                                <div className="quote-inline-divider"></div>

                                                <div className="quote-inline-client">

                                                    <span className="quote-premium-tag">
                                                        CLIENTE
                                                    </span>

                                                    {checkTypeClient === 1 && (
                                                        <div className="quote-inline-name">
                                                            {informationPatient.client ?? "----"}
                                                        </div>
                                                    )}

                                                    {checkTypeClient === 3 &&
                                                        informationCompany.map((_find, index) => (
                                                            <div key={index} className="quote-inline-name">
                                                                {_find?.name ?? "----"}
                                                            </div>
                                                        ))
                                                    }

                                                </div>

                                            </div>

                                            <div className="quote-right">

                                                {checkTypeClient === 1 && (
                                                    <>
                                                        <div className="quote-contact-chip">
                                                            <i className="fa fa-envelope-o"></i>
                                                            <span>{informationPatient.email ?? "----"}</span>
                                                        </div>

                                                        <div className="quote-contact-chip">
                                                            <i className="fa fa-phone"></i>
                                                            <span>{informationPatient.phone ?? "----"}</span>
                                                        </div>
                                                    </>
                                                )}

                                                {checkTypeClient === 3 &&
                                                    informationCompany.map((_find, index) => (
                                                        <React.Fragment key={index}>
                                                            <div className="quote-contact-chip">
                                                                <i className="fa fa-envelope-o"></i>
                                                                <span>{_find?.contact_email ?? "----"}</span>
                                                            </div>

                                                            <div className="quote-contact-chip">
                                                                <i className="fa fa-phone"></i>
                                                                <span>{_find?.phone ?? "----"}</span>
                                                            </div>
                                                        </React.Fragment>
                                                    ))
                                                }

                                                <div className="quote-contact-chip quote-branch-chip">
                                                    <i className="fa fa-map-marker"></i>
                                                    <span>{nameBranch}</span>
                                                </div>

                                            </div>
                                        </div>

                                    </div>

                                </Col>

                            </Row>
                            <Row >

                           
                            
                            <Col md="9">

                                <Card className="quoter-mic-table-card mt-4">
                                    <div className='pb-0'>
                                        {!loadingCreate && <div className='table-wrapper-mic'>
                                            <Table className="quoter-mic-table table-xs">
                                                <thead className='b-r-5'>
                                                    <tr>
                                                        <th className="quoter-mic-th">Cantidad</th>
                                                        <th className="quoter-mic-th">Muestra</th>
                                                        <th className="quoter-mic-th">Concepto</th>
                                                        <th className="quoter-mic-th">Metodologia</th>
                                                        <th className={formQuoterMic.id_company !== null ? "d-none" : "quoter-mic-th"}>Subtotal</th>
                                                        <th className={formQuoterMic.id_company !== null ? "d-none" : "quoter-mic-th"} style={{ textAlign: "center", width: "5%", color: "#fff", fontSize: "12px" }}>Descuento</th>
                                                        <th className="quoter-mic-th">Total</th>
                                                        <th className="quoter-mic-th">Iva</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {formQuoterMic.list_type_samples.map((_obj) => {
                                                        return (
                                                            <React.Fragment key={_obj.id}>
                                                                {_obj.list_determinations.map((_find, index) => {
                                                                    const _index = index === 0;
                                                                    const methodology =
                                                                        (_find?.list_nom?.length > 0)
                                                                            ? _find.list_nom
                                                                            : (_find?.ids_mic_noms?.length > 0)
                                                                                ? (_find?.listNorm || []).filter(x =>
                                                                                    _find.ids_mic_noms
                                                                                        .map(String)
                                                                                        .includes(String(x.code))
                                                                                )
                                                                                : (_find?.listNorm?.length > 0)
                                                                                    ? _find.listNorm
                                                                                    : [];

                                                                    console.log({
                                                                        listNorm: _find.listNorm,
                                                                        ids_mic_noms: _find.ids_mic_noms,
                                                                        list_nom: _find.list_nom
                                                                    });

                                                                    return (
                                                                        <tr style={{ paddingBottom: 30 }} key={_find.id}>
                                                                           {_index && (
                                                                                <>
                                                                                    <td
                                                                                        rowSpan={_obj.list_determinations.length}
                                                                                        className="quoter-mic-sample-cell quoter-mic-first-row"
                                                                                    >
                                                                                        {_obj.cant}
                                                                                    </td>

                                                                                    <td
                                                                                        rowSpan={_obj.list_determinations.length}
                                                                                        className="quoter-mic-sample-cell quoter-mic-first-row"
                                                                                    >
                                                                                        {_obj.name_sample}
                                                                                    </td>
                                                                                </>
                                                                            )}
                                                                            
                                                                            <td className="quoter-mic-concept-cell">

                                                                                {_find?.name}
                                                                            </td>

                                                                            <td className="quoter-mic-method-cell">
                                                                                {methodology.length > 0 ? (
                                                                                    <div>
                                                                                        {methodology.map((_x) => (
                                                                                            <label
                                                                                                key={_x.code}
                                                                                                className="quoter-mic-method-label"
                                                                                            >
                                                                                                {_x?.name ?? "------"}
                                                                                            </label>
                                                                                        ))}
                                                                                    </div>
                                                                                ) : (
                                                                                    <label className='f-w-600'>
                                                                                        ---------------------
                                                                                    </label>
                                                                                )}
                                                                            </td>
                                                                            <td className="quoter-mic-price-cell">
                                                                                <label className="quoter-mic-price-label">
                                                                                    ${_find.price}
                                                                                </label>
                                                                            </td>
                                                                            <td
                                                                                className={`
                                                                                    ${formQuoterMic.id_company !== null ? "d-none" : ""}
                                                                                    quoter-mic-discount-cell
                                                                                `}
                                                                            >
                                                                                {_find.discount_par > 0 ? (
                                                                                    <label className="quoter-mic-discount-label">
                                                                                        {_find.discount_par}%
                                                                                    </label>
                                                                                ) : (
                                                                                    <label className="quoter-mic-empty-label">
                                                                                        -------
                                                                                    </label>
                                                                                )}
                                                                            </td>
                                                                           <td
                                                                                className={`
                                                                                    ${formQuoterMic.id_company !== null ? "d-none" : ""}
                                                                                    quoter-mic-total-cell
                                                                                `}
                                                                            >
                                                                                {_find.discount_par > 0
                                                                                    ? `$${Math.round(FormatNumbers(_find.discount_tota, 2))}`
                                                                                    : `$${Math.round(FormatNumbers(_find.can_total, 2))}`
                                                                                }
                                                                            </td>
                                                                            
                                                                            <td className="quoter-mic-iva-cell">
                                                                                <label className="quoter-mic-iva-label">
                                                                                    {_find.value_iva ?? "---"}%
                                                                                </label>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </tbody>
                                            </Table>
                                        </div>}
                                        {loadingCreate && <Col sm="12" md="12" lg="12" className='text-center'>
                                            <img alt="flask" className="animate__animated animate__pulse animate__infinite" src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")} style={{ width: "100px", height: "100px" }} />
                                            <br />
                                            <p className=' text-primary'><label className='f-w-400 f-16'>Generando Cotización</label></p>
                                        </Col>}
                                    </div>
                                    

                                </Card>
                            </Col>
                            
                            {/* {
                            checkTypeClient !== 4 && <Col sm="3" md="3" lg="3" className='mt-4'>
                                <Col sm="12" className='p-l-0 p-r-0'>
                                    <Card style={{ height: "473px" }}>
                                        <Col sm="12">
                                            <h6 className='txt-secondary pt-2'>Resúmen</h6>
                                            <div className='hr-detail-patient '></div>

                                            <Row className='pb-4 pt-4'>
                                                <Col sm="12" md="12" lg="12">
                                                    <label style={{ fontSize: "12px" }} className='f-w-600 '><i className="fa fa-circle text-info"></i> Observaciones del Muestreo</label> <br />
                                                    {formQuoterMic.valid_sampling && <label>{formQuoterMic?.observations ?? "----"}</label>}
                                                </Col>
                                            </Row >
                                            <Row className='pt-4'>
                                                <Col sm="12" md="12" lg="12">
                                                    <label style={{ fontSize: "12px" }} className='f-w-600 '><i className="fa fa-circle text-info"></i> Resúmen del pago</label> <br />
                                                </Col>
                                            </Row >
                                            {formQuoterMic.valid_sampling && <div className="table-responsive pt-1" >
                                                <Table style={{ fontSize: "11px" }}>
                                                    <thead>
                                                        <tr style={{ backgroundColor: "#46AFE5" }}>
                                                            <td colSpan={2} style={{ color: "#fff", textAlign: "center", padding: "5px" }}>
                                                                Detalle de movimientos
                                                            </td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ padding: "5px" }}>
                                                                <label className='f-12'>Subtotal</label>

                                                            </td>
                                                            <td className="text-center" style={{ padding: "5px" }}>
                                                                <label>$ {FormatNumbers(optionsTotal.subtotal, 2)}</label>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ padding: "5px" }}>
                                                                <label style={{ fontSize: "13px" }} className={total_tax === 16 ? 'f-w-600 txt-primary' : 'f-w-600 txt-secondary'}  >I.V.A({total_tax}%)</label>
                                                            </td>
                                                            <td className="text-center" style={{ padding: "5px" }}>
                                                                <label>$ {FormatNumbers(optionsTotal.tax, 2)}</label>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ padding: "5px" }}>
                                                                <label style={{ fontSize: "13px" }} className='f-w-600'>Total</label>
                                                            </td>
                                                            <td className="text-center f-w-600 bg-dark" style={{ padding: "5px" }}>
                                                                <label style={{ fontSize: "13px" }} className='f-w-600'>$ {FormatNumbers(optionsTotal.total, 2)}</label>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>} <br />
                                            {formQuoterMic.valid_sampling && <Row className="pb-4 pt-2">
                                                <Col sm="12" md="12" lg="12" className='pt-1'>
                                                    <label style={{ fontSize: "12px" }} className='f-w-600 '><i className="fa fa-circle text-info"></i> Acciones</label> <br />
                                                    {
                                                        formQuoterMic.statusQuoter && <div className='pointer' style={{ backgroundColor: "#f8d62b", color: "#fff", paddingBottom: "5px", paddingTop: "5px", textAlign: "center" }} onClick={handleNewQuatation}  ><i className="fa fa-file-pdf-o"></i> Generar Nueva cotización</div>
                                                    }
                                                    {
                                                        !formQuoterMic.statusQuoter && <div style={viewQuoter ? { backgroundColor: "#ffffffff", color: "#fff", paddingBottom: "5px", paddingTop: "5px", textAlign: "center" } : { backgroundColor: "#28a745", color: "#fff", paddingBottom: "5px", paddingTop: "5px", textAlign: "center" }} type="submit" onClick={viewQuoter ? handleClosedQuoter : handleViewQuoter} outline color={viewQuoter ? "danger" : "primary"} size="xs"  > {viewQuoter ? "" : "Previsualizar cotización"} </div>
                                                    } <br />
                                                    {
                                                        !viewQuoter && formQuoterMic.id_quatation !== null && formQuoterMic.valid_sampling && <div className='pointer' style={{ backgroundColor: "#f97316", color: "#fff", paddingBottom: "5px", paddingTop: "5px", textAlign: "center" }} onClick={() => handleChangeTypeClient(4)}  ><i className="fa fa-file-pdf-o"></i>Cargar nueva cotización</div>
                                                    }
                                                </Col>
                                            </Row >}
                                        </Col>
                                    </Card>
                                </Col>

                            </Col>
                            } */}
                            {
                                checkTypeClient !== 4 && <Col sm="3" md="3" lg="3" className='mt-4'>
                        
                                    <div className="payment-button" >
                                        Detallado de la cotización
                                    </div>
                                    {
                                        //? OBSERVATIONS
                                    }
                                    {formQuoterMic.valid_sampling && (
                                        <>
                                            <div className="payment-observation-card mt-2">
                                                <div className="payment-header">
                                                    <h6>Observaciones</h6>
                                                    <span className="payment-dot"></span>
                                                </div>
                                                <p>
                                                    {formQuoterMic?.observations ||
                                                        "No hay observaciones adicionales para este muestreo."}
                                                </p>

                                            </div>
                                            <br />
                                            {
                                                //? PAYMENTS 
                                            }

                                            <div className="payment-summary-card">
                                                
                                                <div className="payment-header">
                                                    <h6>Resumen de Pago</h6>
                                                    <span className="payment-dot"></span>
                                                </div>

                                                <div className="payment-row">
                                                    <span>Subtotal</span>
                                                    <strong>$ {FormatNumbers(optionsTotal.subtotal, 2)}</strong>
                                                </div>

                                                <div className="payment-row">
                                                    <span>I.V.A ({total_tax}%)</span>
                                                    <strong>$ {FormatNumbers(optionsTotal.tax, 2)}</strong>
                                                </div>

                                                <hr />

                                                <div className="payment-total">
                                                    <span>Total</span>
                                                    <strong>
                                                        $ {FormatNumbers(optionsTotal.total, 2)}
                                                    </strong>
                                                </div>

                                            </div>
                                            {
                                                //? ACTIONS
                                            }

                                            <div className="payment-actions-mic-card mt-3">
                                                <div className="payment-header">
                                                    <h6>Acciones</h6>
                                                    <span className="payment-dot"></span>
                                                </div>

                                                <div className="quoter-mic-payment-actions">

                                                    {formQuoterMic.statusQuoter && (
                                                        <button
                                                            className="action-quoter-mic-btn secondary"
                                                            onClick={downloadQuoter}
                                                        >
                                                            <i className="icofont icofont-download-alt"></i>

                                                            Descargar cotización
                                                        </button>
                                                    )}

                                                    {!formQuoterMic.statusQuoter && (
                                                        <button
                                                            className="action-quoter-mic-btn action-quoter-mic-btn primary"
                                                            onClick={formQuoterMic.code_quatation === null ? saveQuatation : updateQuatation}
                                                            disabled={loadingCreate}
                                                        >
                                                            <i className="icofont icofont-file-pdf"></i>

                                                            {formQuoterMic.code_quatation === null
                                                                ? "Generar cotización"
                                                                : "Guardar edición"}
                                                        </button>
                                                    )}
                                                    
                                                    {formQuoterMic.statusQuoter && (
                                                        <button
                                                            className="action-quoter-mic-btn warning"
                                                            onClick={handleNewQuatation} 
                                                        >
                                                            <i className="fa fa-file-pdf-o"></i> 

                                                            Generar Nueva cotización
                                                        </button>
                                                    )}
                                                    
                                                    {!formQuoterMic.statusQuoter && (
                                                        <button
                                                            className="action-quoter-mic-btn warning"
                                                            onClick={handleClosedQuoter}
                                                            disabled={loadingCreate}
                                                        >
                                                            <i className="fa fa-edit"></i>

                                                            Editar cotización
                                                        </button>
                                                    )}

                                                    {formQuoterMic.statusQuoter && (
                                                        <button
                                                            className="action-quoter-mic-btn sucess"
                                                            onClick={() => handleNavigateSampling(formQuoterMic.code_quatation)}
                                                        >
                                                            <i className="icofont icofont-id"></i>

                                                            Continuar Muestreo
                                                        </button>
                                                    )}

                                                    {/* <button
                                                        className="action-quoter-mic-btn goBack"
                                                        onClick={handleGoBack}
                                                    >
                                                        <i className="fa fa-arrow-left"></i>
                                                        Regresar
                                                    </button> */}

                                                        
                                                    

                                                </div>

                                            </div>
                                            <br /><br /><br /> <br /> <br />

                                            

                                        
                                        </>
                                    )}
                                </Col>
                                }   
                                </Row>
                            </Col>



                    }

                    

                </Row>
                {/* </Container> */}


            </>



        </Fragment >
    )
}
